module.exports = __webpack_public_path__ + "static/media/icono_like_vacio.00d83b34.svg";